export enum SensitivityName {
  PUBLIC = 'Public',
  CONFIDENTIAL = 'Confidential',
  HIGHLY_CONFIDENTIAL = 'Highly Confidential',
  PRIVATE_CONFIDENTIAL = 'Private Confidential',
}
